const MainFooter = () => import("@/components/MainFooter/MainFooter.vue")
const DisconnectButton = () => import("@/_partials/Buttons/Disconnect/Disconnect.vue")
import inscriptionService from "@/services/inscription";
import { CANDIDATE_MENU } from "@/constants/candidateMenu";
import { mapActions, mapGetters } from "vuex";
import conditionHelper from "@/helpers/condition";

export default {
  components: {
    MainFooter,
    DisconnectButton,
  },
  data() {
    return {
      emailConfirmationAlert: {
        show: false,
        message: "",
      },
      navBarItems: CANDIDATE_MENU.MENU_ITEMS,
      fullWidthScreen: ['candidate-job-offer-details']
    };
  },
  computed: {
    ...mapGetters("auth", {
      user: 'getUser'
    }),
    ...mapGetters('auth', {
      generalSetting : 'generalSetting'
    }),
    ...mapGetters("notification", ['notifications', 'unreadNotifs']),
    currentRouteFullName() {
      return this.$router.currentRoute.fullPath;
    },
    navBarItemsFiltered() {
      if (this.user.accountCreationStatus !== 5) {
        const found = [];

        this.navBarItems.filter(item => !item.hidden).forEach(function(element) {
          if (element.filters.hideWhenEmailUnconfirmed === false) {
            found.push(element);
          }
        });

        return found;
      } else {
        const menu = [];

        this.navBarItems.filter(item => !item.hidden).forEach((item) => {
          if(item.items) {
            const sub = [];
            item.items.filter(subItem => !subItem.hidden).forEach((subItem) => {
              if(!subItem.exADV || this.user.applicationStatus === 13) {
                sub.push(subItem);
              }
            });
            item.items = sub;
          }
          if(!item.exADV || this.user.applicationStatus === 13) {
            menu.push(item);
          }
        });
        return menu;
      }
    },
  },
  beforeCreate() {
    this.$store.dispatch("auth/CREATE_LAYOUT_INSTANCE")
  },
  created() {
    if (this.notifications === null) {
      this.getNotifications({id: this.user.pkAdv});
    }
  },
  methods: {
    ...mapActions('notification', {
      getNotifications: 'GET_NOTIFICATIONS'
    }),
    resendConfirmationEmail() {
      inscriptionService
        .confirmationByEmail()
        .then((res) => {
          this.emailConfirmationAlert.variant = res.success
            ? "success"
            : "danger";
          this.emailConfirmationAlert.message = res.message;
          this.emailConfirmationAlert.show = true;
        })
        .catch((err) => {
          this.emailConfirmationAlert.message = err.message;
          this.emailConfirmationAlert.variant = "danger";
          this.emailConfirmationAlert.show = true;
        });
    },
    modifyMyEMail() {
      // TODO
      alert("Not implemented yet !"); 
      // this.$router.go();
    },
    reverifyActivation() {
      this.$router.go();
    },
    showNotification() {
      return conditionHelper('rcfnotificationadv');
    },
    showMenu() {
      this.$refs["modalMenu"].toggle();
    },
    hideMenu() {
      this.$refs["modalMenu"].hide();
    },
    onNavItemSameRoute(item) {
      if (this.$route.name === item.route) {
        this.$root.$emit('reset-support-form');
      }
    },
    onGo(route, mobileMode = false) {
      
      if (mobileMode) {
        this.hideMenu();
      }
      this.$router.push({ name: route })
    }
  },
};
